import SchemasService from '@Services/SchemasService';
import * as WindowHelper from '@Services/WindowHelper';
import AppStorage from '@Services/AppStorage';
import debounce from 'lodash/debounce';

const DEFAULT_FIXED_FONT_SIZE = 0.85;

let fixedFontSize;
let offResize;

function getStorage() {
  return AppStorage.instance.get('userInterface') || {};
}

export function get(key) {
  const storage = getStorage();
  return storage[key];
}

export function set(key, value) {
  const storage = getStorage();
  storage[key] = value;
  AppStorage.instance.set('userInterface', storage);
}

export function applyUserFontSizeSettings(currentFontSize, newFontSize) {
  const html = document.querySelector('html');
  if (currentFontSize) {
    html?.classList.remove(`font-size-${currentFontSize * 100}${fixedFontSize ? '--fixed' : ''}`);
  }
  if (newFontSize) {
    html?.classList.add(`font-size-${newFontSize * 100}${fixedFontSize ? '--fixed' : ''}`);
  }
}

export function applySchema(fontColor = 'default', contrast = 1) {
  return SchemasService.applySchema(fontColor, contrast);
}

function _setFixedFontSize(fontSize, reset = false) {
  if (!reset) {
    fixedFontSize = fontSize;
    applyUserFontSizeSettings(null, fontSize);
  } else {
    applyUserFontSizeSettings(fontSize, null);
    fixedFontSize = null;
  }
}

export function initOnResize() {
  const handler = (event) => {
    if (WindowHelper.isBreakpointView()) {
      // eslint-disable-next-line no-unused-expressions
      !fixedFontSize && _setFixedFontSize(DEFAULT_FIXED_FONT_SIZE, false);
    } else if (event) {
      // Case when browser window resized - event passed, so it is not initial handler call
      _setFixedFontSize(DEFAULT_FIXED_FONT_SIZE, true);
    }
  };

  handler();
  offResize = WindowHelper.onResize(debounce(handler, 300));
}

export function resetOnResize() {
  // eslint-disable-next-line no-unused-expressions
  offResize && offResize();
  fixedFontSize = null;
}

export function isFixedFontSize() {
  return fixedFontSize;
}
